module.exports = __webpack_public_path__ + "static/img/img-finance-sharinglist-success.401ace0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/finance/sharinglist/img-finance-sharinglist-success.png
// module id = 2Diw
// module chunks = 1